import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const OnboardingPage = lazy(() =>
  import('@/features/onboarding/OnboardingPage').then((m) => ({ default: m.OnboardingPage })),
);

function OnboardingRoute() {
  const { step } = Route.useSearch();
  return (
    <Suspense>
      <OnboardingPage initialStep={step} />
    </Suspense>
  );
}

export const Route = createFileRoute('/app/onboarding')({
  validateSearch: (search: Record<string, unknown>) => ({
    step: typeof search.step === 'number' ? search.step : Number(search.step ?? 0),
  }),
  component: OnboardingRoute,
});
